import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Command, Loader2, ShieldAlert } from "lucide-react";

export function ForcePasswordChange() {
  const { refresh, logout } = useAuth();
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (pw.length < 6) return setError("Password must be at least 6 characters");
    if (pw !== confirm) return setError("Passwords do not match");
    setLoading(true);
    try {
      await api.post("/auth/change-password", { new_password: pw });
      await refresh();
    } catch (err) { setError(formatApiError(err.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  return (
    <div className="fixed inset-0 z-50 bg-[#F9F9FA] flex items-center justify-center px-6" data-testid="force-change-screen">
      <div className="w-full max-w-sm">
        <div className="h-10 w-10 bg-primary flex items-center justify-center mb-6"><Command className="h-5 w-5 text-white" /></div>
        <div className="flex items-center gap-2 text-[#F5A623] mb-2"><ShieldAlert className="h-4 w-4" /><span className="overline text-[0.55rem]">Action required</span></div>
        <h1 className="font-heading font-bold text-2xl">Set a new password</h1>
        <p className="text-sm text-muted-foreground mt-2 mb-6">Your account is using a temporary password. Choose a new one to continue.</p>
        <form onSubmit={submit} className="space-y-4">
          <div className="space-y-2"><Label>New password</Label><Input type="password" value={pw} onChange={(e) => setPw(e.target.value)} required data-testid="force-new-password" className="bg-white border-black/10 rounded-none h-11" /></div>
          <div className="space-y-2"><Label>Confirm password</Label><Input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required data-testid="force-confirm-password" className="bg-white border-black/10 rounded-none h-11" /></div>
          {error && <p data-testid="force-error" className="text-sm text-destructive bg-destructive/10 border border-destructive/30 px-3 py-2">{error}</p>}
          <Button type="submit" disabled={loading} data-testid="force-submit" className="w-full h-11 rounded-none bg-primary hover:bg-[#09090B] transition-colors font-medium">{loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Update & continue"}</Button>
        </form>
        <button onClick={logout} className="block mx-auto text-sm text-muted-foreground hover:text-[#09090B] mt-4" data-testid="force-signout">Sign out</button>
      </div>
    </div>
  );
}
